import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { useRoutes } from '../../hooks/useRoutes';
import { RoutingComponents } from './components/RoutingComponents';
export const CurrentRoute = ({ className, style, loadingSpinner }) => {
    const routes = useRoutes();
    return (_jsx(Suspense, Object.assign({ fallback: loadingSpinner !== null && loadingSpinner !== void 0 ? loadingSpinner : null }, { children: _jsx("div", Object.assign({ className: className, style: style }, { children: _jsx(RoutingComponents, { routes: routes }, void 0) }), void 0) }), void 0));
};
//# sourceMappingURL=CurrentRoute.js.map